import React, { lazy } from 'react';
export function ProductDetails() {
  const scrollToProductOptions = () => {
    document.getElementById('product-options')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full" data-id="element-244">
      {/* White Background Section */}
      <div className="bg-white py-12 px-4" data-id="element-245">
        <div className="max-w-4xl mx-auto text-black text-center" data-id="element-246">
          <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-247">
            The 10 Research-Backed Botanicals Inside
          </h2>
          <p className="mb-8" data-id="element-248">
            Our breakthrough formula combines ancient Indonesian remedies with
            modern science to create a powerful solution for hair loss. Each
            ingredient is carefully selected for its proven benefits.
          </p>
          <div className="bg-white rounded-lg p-6 text-black" data-id="element-249">
            <div className="flex flex-col md:flex-row items-center" data-id="element-250">
              <div className="md:w-1/2 mb-6 md:mb-0" data-id="element-251">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qw3MHWgYQuJh2yNDkmBEUE/ChatGPT_Image_3_%CE%91%CF%85%CE%B3_2025%2C_02_47_30_%CE%BC.%CE%BC..webp" alt="Hair Growth Oil 3.0 ingredients" className="max-w-full h-auto" loading="lazy" width="400" height="300" decoding="async" data-id="element-252" />
              </div>
              <div className="md:w-1/2 md:pl-6 text-left" data-id="element-253">
                <h3 className="text-xl font-bold mb-4" data-id="element-254">
                  Power-Packed Ingredients:
                </h3>
                <ul className="space-y-4" data-id="element-255">
                  <li className="flex items-start" data-id="element-256">
                    <span className="mr-2 text-xl" data-id="element-257">🌿</span>
                    <div data-id="element-258">
                      <span className="font-bold" data-id="element-259">
                        Artemisia Vulgaris (Mugwort)
                      </span>{' '}
                      - "The Toxic Cell Blocker"
                      <p className="text-sm text-gray-600" data-id="element-260">
                        Deactivates hair loss cellular inflammation at the root
                        level
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-261">
                    <span className="mr-2 text-xl" data-id="element-262">🔥</span>
                    <div data-id="element-263">
                      <span className="font-bold" data-id="element-264">Wild Indonesian Ginger</span>{' '}
                      - "The Scalp Revitalizer"
                      <p className="text-sm text-gray-600" data-id="element-265">
                        Reduces inflammation and boosts blood circulation
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-266">
                    <span className="mr-2 text-xl" data-id="element-267">🛡️</span>
                    <div data-id="element-268">
                      <span className="font-bold" data-id="element-269">Sophora Flavescens</span> -
                      "The Toxin Shield"
                      <p className="text-sm text-gray-600" data-id="element-270">
                        Neutralizes environmental pollutants attacking follicles
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-271">
                    <span className="mr-2 text-xl" data-id="element-272">🌱</span>
                    <div data-id="element-273">
                      <span className="font-bold" data-id="element-274">Polygonum Multiflorum</span> -
                      "The Follicle Awakener"
                      <p className="text-sm text-gray-600" data-id="element-275">
                        Activates dormant hair follicles for new growth
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-276">
                    <span className="mr-2 text-xl" data-id="element-277">🌲</span>
                    <div data-id="element-278">
                      <span className="font-bold" data-id="element-279">Platycladus Orientalis</span>{' '}
                      - "The Strand Strengthener"
                      <p className="text-sm text-gray-600" data-id="element-280">
                        Reinforces hair fibers for thicker, stronger strands
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-281">
                    <span className="mr-2 text-xl" data-id="element-282">🌟</span>
                    <div data-id="element-283">
                      <span className="font-bold" data-id="element-284">Angelica Archangelica</span> -
                      "The Nutrient Delivery System"
                      <p className="text-sm text-gray-600" data-id="element-285">
                        Enhances absorption of other ingredients
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-286">
                    <span className="mr-2 text-xl" data-id="element-287">🍃</span>
                    <div data-id="element-288">
                      <span className="font-bold" data-id="element-289">Morus Alba</span> - "The DHT
                      Defender"
                      <p className="text-sm text-gray-600" data-id="element-290">
                        Blocks DHT production at the scalp level
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-291">
                    <span className="mr-2 text-xl" data-id="element-292">💪</span>
                    <div data-id="element-293">
                      <span className="font-bold" data-id="element-294">Panax Ginseng</span> - "The
                      Growth Accelerator"
                      <p className="text-sm text-gray-600" data-id="element-295">
                        Speeds up the hair growth cycle for faster results
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* How It Works Section */}
      <div className="py-12 px-4 bg-white" data-id="element-296">
        <div className="max-w-4xl mx-auto" data-id="element-297">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-298">
            How It Works
          </h2>
          <div className="grid grid-cols-1 gap-8" data-id="element-299">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-300">
              <h3 className="text-xl font-bold mb-4" data-id="element-301">
                Step 1: Deactivate the Toxic Cells
              </h3>
              <p className="mb-4" data-id="element-302">
                Artemisia Vulgaris eliminates free radicals and suppresses
                cellular activation, removing inflammatory triggers that
                activate cellular inflammation switches.
              </p>
              <div className="relative w-full rounded-lg overflow-hidden" data-id="element-303">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rcicBq67TCmYSzWvWoPd3S/ChatGPT_Image_2_%CE%A3%CE%B5%CF%80_2025%2C_03_44_26_%CE%BC.%CE%BC..webp" alt="Step 1: Deactivate the Toxic Cells" className="w-full h-auto" loading="lazy" width="800" height="400" decoding="async" data-id="element-304" />
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-305">
              <h3 className="text-xl font-bold mb-4" data-id="element-306">
                Step 2: Neutralize Environmental Toxins
              </h3>
              <p className="mb-4" data-id="element-307">
                Wild Indonesian Ginger calms cellular inflammation around the
                scalp that activates the Toxic Cells, while Sophora Flavescens
                neutralizes environmental toxins attacking follicles.
              </p>
              <div className="relative w-full rounded-lg overflow-hidden" data-id="element-308">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vX5ikuENYrR22NmYsA98HD/ChatGPT_Image_2_%CE%A3%CE%B5%CF%80_2025%2C_03_58_01_%CE%BC.%CE%BC..webp" alt="Step 2: Neutralize Environmental Toxins" className="w-full h-auto" loading="lazy" width="800" height="400" decoding="async" data-id="element-309" />
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-310">
              <h3 className="text-xl font-bold mb-4" data-id="element-311">
                Step 3: Reactivate Dormant Follicles
              </h3>
              <p className="mb-4" data-id="element-312">
                Polygonum Multiflorum activates dormant follicular stem cells
                while maintaining cellular suppression, promoting new hair
                growth where you thought it was impossible.
              </p>
              <div className="relative w-full rounded-lg overflow-hidden" data-id="element-313">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dJoQbiMNuyc9RqWEkzb1cz/ChatGPT_Image_2_%CE%A3%CE%B5%CF%80_2025%2C_04_01_29_%CE%BC.%CE%BC..webp" alt="Step 3: Reactivate Dormant Follicles" className="w-full h-auto" loading="lazy" width="800" height="400" decoding="async" data-id="element-314" />
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-315">
              <h3 className="text-xl font-bold mb-4" data-id="element-316">
                Step 4: Extend Growth Phase
              </h3>
              <p className="mb-4" data-id="element-317">
                Our proprietary blend prolongs the anagen growth phase up to 8
                years, ensuring your hair grows thicker, stronger, and longer
                than ever before.
              </p>
              <div className="relative w-full rounded-lg overflow-hidden" data-id="element-318">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j4GPjAZXqhE4r6t8ALYmNY/ChatGPT_Image_2_%CE%A3%CE%B5%CF%80_2025%2C_04_12_09_%CE%BC.%CE%BC..webp" alt="Step 4: Extend Growth Phase" className="w-full h-auto" loading="lazy" width="800" height="400" decoding="async" data-id="element-319" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export default {
  ProductDetails
};